.root {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.header {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.total-card {
  align-items: center;
  background: var(--color-surface-subtle, var(--color-surface));
  border: 1px solid var(--color-border-subtle, var(--color-border));
  border-radius: 12px;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  padding: 14px 16px;
}

.total-amounts {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.bar-row {
  background: var(--color-muted);
  border-radius: 999px;
  display: flex;
  height: 14px;
  overflow: hidden;
  width: 100%;
}

.bar-segment {
  flex-shrink: 0;
  height: 100%;
  min-width: 0;
}

.bar-empty {
  flex: 1;
  height: 100%;
}

.category-list {
  border: 1px solid var(--color-border);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0;
  overflow: hidden;
  padding: 0;
}

.category-row {
  align-items: center;
  display: grid;
  // dot · label · subtitle · spacer · pct · amount.
  // The 1fr spacer pushes pct + amount to the right edge so they line up
  // across rows even when subtitles vary in length.
  gap: 10px;
  grid-template-columns: 10px auto auto 1fr auto auto;
  padding: 12px 14px;

  & + & {
    border-top: 1px solid var(--color-border);
  }
}

.row-subtitle {
  // Truncate with ellipsis when the chosen accommodation title is long
  // enough to push pct + amount off the right edge.
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.row-pct {
  // Align the percent column even when subtitle is missing.
  grid-column: 5;
}

.dot {
  border-radius: 50%;
  height: 10px;
  width: 10px;
}

.footer {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: space-between;
  margin-top: 4px;
}
